<div class="cdk-overlay-container" [ngClass]="{ 'dark-theme' : isDarkTheme}">
  <div class="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing"></div>
  <div class="cdk-global-overlay-wrapper">
    <div [id]="setupService.id" class="test-setup">
      <div class="setup">
        <div class="header-items">
          <div class="header">
            <div class="title-block">
              <div
                class="icon matIcon"
                *ngIf="setupService.iconType==='material' && setupService.iconName"
              >
                <i class="material-icons mdi" [ngClass]="setupService.iconName"></i>
              </div>
              <div class="icon" *ngIf="setupService.iconType==='image' && setupService.iconName">
                <img [src]="getIconName()" alt="" />
              </div>
              <div class="title" *ngIf="setupService.currentTab">
                <div>{{setupService.title}}</div>
                <div class="subTitle description" *ngIf="setupService.description">
                  <span>{{setupService.description}}</span>
                </div>
              </div>
            </div>
            <div class="control">
              <div class="template" *ngIf="templateName">
                <div class="template-label">Template:</div>
                <div class="template-name">{{templateName}}</div>
              </div>
              <button mat-button [matMenuTriggerFor]="menu" *ngIf="setupService?.showActionMenu">
                <i class="mdi mdi-dots-horizontal"></i>
              </button>
              <mat-menu #menu="matMenu">
                <button
                  mat-menu-item
                  (click)="downloadTestConfig();"
                  [disabled]="!setupService.isValid() || setupService.isLoading"
                >
                  <i class="mdi mdi-download-box"></i>Get configuration
                </button>
                <button mat-menu-item (click)="openTemplates()">
                  <i class="mdi mdi-file-document"></i>Open template
                </button>
                <button mat-menu-item (click)="saveTestConfig()">
                  <i class="mdi mdi-content-save"></i>Save template
                </button>
              </mat-menu>
              <button
                mat-flat-button
                (click)="toggleFinish();"
                [disabled]="!setupService.isValid() || setupService.isLoading"
              >
                {{setupService.currentConfig.buttonName || "ADD" }}
              </button>

              <div class="vertical-separator"></div>

              <i class="mdi mdi-close close" (click)="toggleClose()"></i>
            </div>
          </div>
          <div class="tabs" *ngIf="setupService.tabs?.length > 1">
            <div class="tab" *ngFor="let tab of setupService.tabs;let i = index; let last = last;">
              <div
                class="name"
                [class.selected]="i === setupService.currentTab.config.index"
                [class.errorTab]="!isValidTab(i)"
                (click)="toggleTabChange(i)"
              >
                {{tab.config.name}}
              </div>
            </div>
          </div>
        </div>

        <div class="body">
          <div class="content">
            <ng-container *ngIf="!setupService.noResponseError">
              <span class="error" *ngFor="let error of setupService.errors">{{error}}</span>
            </ng-container>
            <div class="tab-content">
              <div [hidden]="hideCurrentTab(1)">
                <ng-container #contentPlaceholder1> </ng-container>
              </div>
              <div [hidden]="hideCurrentTab(2)">
                <ng-container #contentPlaceholder2> </ng-container>
              </div>
              <div [hidden]="hideCurrentTab(3)">
                <ng-container #contentPlaceholder3> </ng-container>
              </div>
              <div [hidden]="hideCurrentTab(4)">
                <ng-container #contentPlaceholder4> </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
